import { animate, inView, scroll } from 'motion';

const faqs = () => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('faqs', {
      blocks: [],
      categories: [],
      active: '',
      activeIndex: 0,
      height: 0,
      init() {
        const faqs = document.querySelectorAll('.faqs-section');

        if (faqs) {
          faqs.forEach((faq) => {
            const category = faq.querySelector('[data-category]').dataset.category;

            this.categories.push(category);
          });
        }
      },
      get blocksByCategory() {
        return this.blocks.filter((block) => {
          return this.categories.includes(block.category);
        });
      },
    });

    Alpine.data('faq', (category = '') => ({
      category,
      init() {
        this.$nextTick(() => {
          this.$store.faqs.blocks.push(this.$root);

          this.$store.faqs.height += this.$root.offsetHeight;
        });

        const observerCallback = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.$store.faqs.active = entry.target.innerText;

              this.$store.faqs.activeIndex = this.$store.faqs.categories.indexOf(this.$store.faqs.active);

              if (this.$refs.active) {
                this.$refs.active.style.transform = `translateY(${100 * catIndex}%)`;
              }
            }
          });
        };

        const observer = new IntersectionObserver(observerCallback, {
          rootMargin: '-20% 0px -80% 0px',
          threshold: 0,
        });

        observer.observe(this.$refs.title);
      },
    }));
  });
};

export default faqs;
